import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";

import { Purpose } from "../../enums/purpose.ts";
import {
  DealCreationRequest,
  DealCreationResponse,
  LoanIntent,
  SessionPublicAPIsForStartFlowApi,
} from "../../orchestrator-api-client";
import { YesNo } from "../../enums/yes-no.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const getLoanIntent = (searchParams: URLSearchParams): LoanIntent => {
  return {
    amount: Number(searchParams.get("amount")),
    term: Number(searchParams.get("term")),
    purpose: searchParams.get("purpose") as Purpose,
    tan: Number(searchParams.get("tan")),
    taeg: Number(searchParams.get("taeg")),
    installmentsAmount: Number(searchParams.get("installments_amount")),
    insurance: searchParams.get("insurance") === YesNo.YES.toLowerCase(),
  };
};

export const getRequestIdForLogging = (
  searchParams: URLSearchParams,
): string => {
  return searchParams.get("requestId") ?? "";
};

export type CreateDealActionResult = {
  dealId: DealCreationResponse["dealHubspotId"];
  loanIntent: LoanIntent;
};

export const createDeal = createAsyncThunk<
  CreateDealActionResult,
  URLSearchParams,
  ThunkApi
>("createDeal", async (searchParams, { dispatch, rejectWithValue }) => {
  try {
    const loanIntent = getLoanIntent(searchParams);
    const requestId = getRequestIdForLogging(searchParams);
    //if dev set insurance

    const dealCreationRequest: DealCreationRequest = {
      loanIntent,
      // applicationId,
      channelForm: searchParams.get("form_channel") || "CONTE",
      latestSource: searchParams.get("source") || "--",
      latestSourceDrillDown: searchParams.get("source_drill_down") || "--",
      originalUtmCampaign: searchParams.get("utm_campaign") || "--",
      originalUtmContent: searchParams.get("utm_content") || "--",
      originalUtmMedium: searchParams.get("utm_medium") || "--",
      originalUtmSource: searchParams.get("utm_source") || "--",
      originalUtmTerm: searchParams.get("utm_term") || "--",
    };

    const {
      data: { dealHubspotId },
    } = await new SessionPublicAPIsForStartFlowApi().createDeal(
      dealCreationRequest,
      {
        params: {
          requestId: requestId,
        },
      },
    );

    if (typeof dealHubspotId === "undefined") {
      throw new Error("Deal Id non presente");
    }

    return {
      dealId: dealHubspotId,
      loanIntent,
    };
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Creazione pratica",
      description:
        "Non siamo riusciti a creare la pratica.\n Puoi riprovare o contattare il supporto",
      isDismissible: false,
      onSubmit: () => dispatch(createDeal(searchParams)),
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
